module.exports = __webpack_public_path__ + "static/homeBtn-002f1dc95814989032e695d60752d7ac.png";